export default __webpack_public_path__ + "cfe5e18abb506650b1b49623ba3f45e6.png";